import React from "react";
import { userDetails, userSettings } from "../../../api/user";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setUser } from "../../../redux/actions/user_actions";
import { setProducts } from "../../../redux/actions/product_actions";
import * as api from "../../../api";
import { useEffectOnce } from "react-use";
import ProfileImage from "./components/profile_image";
import { useUserStore } from "../../../store/user_store";

// SVG Icons replacing Ant Design & MUI icons
const EmailIcon = ({ className }) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
    </svg>
);

const UserIcon = ({ className }) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
        <circle cx="12" cy="7" r="4" />
    </svg>
);

const EditIcon = ({ className }) => (
    <svg className={className || "w-4 h-4"} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
        <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
);

const SpinnerIcon = ({ className }) => (
    <svg className={`animate-spin ${className || "w-5 h-5"}`} fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
    </svg>
);

const CheckIcon = ({ className }) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

function formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{6})$/);
    if (match) {
        return '+' + match[1] + ' ' + match[2] + ' ' + match[3];
    };
    return "";
}

const SettingsPage = () => {
    const userState = useUserStore();
    const user = userState.user;
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageurl] = useState();
    const [name, setName] = useState(user != null ? user.name : "");
    const [phone, setPhone] = useState(user != null ? user.email : "");
    const [userid, setUserid] = useState();
    const [file, setFile] = useState();
    const [toast, setToast] = useState({ visible: false, message: '', type: 'success' });

    const showToast = (message, type = 'success') => {
        setToast({ visible: true, message, type });
        setTimeout(() => setToast({ visible: false, message: '', type: 'success' }), 3000);
    };

    function beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            showToast('Изображение должно быть менее 2MB!', 'error');
            return false;
        }
        setFile(file);
        return false;
    }

    const dispatch = useDispatch();
    const limit = 20;
    const [offset, setOffset] = useState(0);

    const fetchUserProducts = async () => {
        let _products = await api.fetchUserProducts({ 'sub': true });
        if (_products != null) {
            dispatch(setProducts(_products));
            setOffset(offset + limit);
        }
    };

    const saveSettings = async () => {
        const formData = new FormData();
        if (name != null) {
            if (name.length > 4) {
                formData.append('name', name);
            } else {
                showToast('Имя не может быть короче 4 символов', 'error');
                return;
            }
        }
        if (file != null) {
            formData.append('avatar', file);
        }
        if (name != null || file != null) {
            formData.append('_method', 'PATCH');
            setLoading(true);
            const result = await userSettings(formData, userid,
                function (data) {
                    setTimeout(() => {
                        showToast('Успешно сохранено!', 'success');
                    }, 500);
                    setLoading(false);
                    userState.fetchUser();
                },
                function (data) {
                    console.log("Error");
                    showToast('Произошла ошибка', 'error');
                    setLoading(false);
                },
            );
        }
    };

    useEffectOnce(() => {
        document.title = "Настройки пользователя";
        fetchUserProducts();
    });

    return (
        <>
            {/* Toast Notification */}
            {toast.visible && (
                <div className="fixed top-4 left-4 right-4 sm:left-auto sm:right-6 sm:top-6 z-[9999] animate-fade-in-up">
                    <div className={`flex items-center gap-3 px-4 py-3 rounded-xl shadow-xl border backdrop-blur-sm ${
                        toast.type === 'success'
                            ? 'bg-emerald-50/95 border-emerald-200 text-emerald-700'
                            : 'bg-rose-50/95 border-rose-200 text-rose-700'
                    }`}>
                        {toast.type === 'success' ? (
                            <div className="w-6 h-6 rounded-full bg-emerald-500 flex items-center justify-center flex-shrink-0">
                                <CheckIcon className="w-3.5 h-3.5 text-white" />
                            </div>
                        ) : (
                            <div className="w-6 h-6 rounded-full bg-rose-500 flex items-center justify-center flex-shrink-0">
                                <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </div>
                        )}
                        <span className="text-sm font-medium">{toast.message}</span>
                    </div>
                </div>
            )}

            <div className="w-full">
                {/* Profile Card */}
                <div className="relative overflow-hidden bg-white border-0 sm:border border-slate-100 rounded-none sm:rounded-2xl shadow-none sm:shadow-sm">
                    {/* Gradient Header Background */}
                    <div className="h-24 sm:h-32 bg-gradient-to-br from-blue-500 via-blue-600 to-indigo-700 relative">
                        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0iYSIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBwYXR0ZXJuVHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cmVjdCB3aWR0aD0iMSIgaGVpZ2h0PSI0MCIgZmlsbD0icmdiYSgyNTUsMjU1LDI1NSwwLjA1KSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3QgZmlsbD0idXJsKCNhKSIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIvPjwvc3ZnPg==')] opacity-50" />
                    </div>

                    {/* Avatar - Overlapping header */}
                    <div className="flex justify-center -mt-14 sm:-mt-16 relative z-10">
                        <div className="ring-4 ring-white rounded-full shadow-xl">
                            <ProfileImage
                                image={user != null ? user.image : ""}
                                onChange={(file) => {
                                    setFile(file);
                                }}
                            />
                        </div>
                    </div>

                    {/* User Quick Info */}
                    <div className="text-center mt-4 pb-2">
                        <h2 className="text-xl font-bold text-slate-800">
                            {user?.name || 'Пользователь'}
                        </h2>
                        <p className="text-sm text-slate-400 mt-0.5">{user?.email || ''}</p>
                        {user?.is_business && (
                            <span className="inline-flex items-center gap-1 mt-2 px-3 py-1 bg-amber-50 text-amber-600 text-xs font-semibold rounded-full border border-amber-200">
                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                                </svg>
                                Бизнес-аккаунт
                            </span>
                        )}
                    </div>

                    {/* Edit Form */}
                    <div className="px-4 sm:px-6 pb-8 pt-4">
                        <div className="max-w-md mx-auto space-y-3 sm:space-y-4">
                            {/* Name Field */}
                            <div className="space-y-1.5">
                                <label className="flex items-center gap-2 text-xs font-semibold text-slate-500 uppercase tracking-wider">
                                    <UserIcon className="w-4 h-4 text-slate-400" />
                                    Имя
                                </label>
                                <div className="relative group">
                                    <input
                                        type="text"
                                        className="w-full px-4 py-3.5 bg-slate-50 border border-slate-200 rounded-xl text-sm text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-400 focus:bg-white transition-all duration-200 pr-10"
                                        placeholder="Введите имя"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                    <div className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-300 group-focus-within:text-blue-400 transition-colors">
                                        <EditIcon className="w-4 h-4" />
                                    </div>
                                </div>
                            </div>

                            {/* Email/Phone Field */}
                            <div className="space-y-1.5">
                                <label className="flex items-center gap-2 text-xs font-semibold text-slate-500 uppercase tracking-wider">
                                    <EmailIcon className="w-4 h-4 text-slate-400" />
                                    Email
                                </label>
                                <div className="relative">
                                    <input
                                        type="text"
                                        className="w-full px-4 py-3.5 bg-slate-100 border border-slate-200 rounded-xl text-sm text-slate-500 cursor-not-allowed"
                                        placeholder="Email"
                                        value={phone}
                                        disabled
                                    />
                                    <div className="absolute right-3 top-1/2 -translate-y-1/2">
                                        <svg className="w-4 h-4 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                            <path d="M7 11V7a5 5 0 0110 0v4" />
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            {/* Balance Info */}
                            {user?.balance !== undefined && (
                                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-100 rounded-xl p-4 flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-md shadow-blue-500/20">
                                            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.5">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a2.25 2.25 0 00-2.25-2.25H15a3 3 0 11-6 0H5.25A2.25 2.25 0 003 12m18 0v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 9m18 0V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v3" />
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="text-xs text-slate-500 font-medium">Баланс</p>
                                            <p className="text-lg font-bold text-slate-800">{user.balance} сом</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Save Button */}
                            <button
                                onClick={saveSettings}
                                disabled={loading}
                                className="w-full py-4 bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 text-white font-semibold text-[15px] rounded-xl shadow-lg shadow-blue-500/25 hover:shadow-xl hover:shadow-blue-500/30 active:scale-[0.98] transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                            >
                                {loading ? (
                                    <>
                                        <SpinnerIcon className="w-5 h-5 text-white" />
                                        Сохранение...
                                    </>
                                ) : (
                                    <>
                                        <CheckIcon className="w-5 h-5" />
                                        Сохранить изменения
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SettingsPage;